"use client";

import getPriceInfoFromProduct, {
  PriceType,
} from "@/utils/elevate/getPriceInfoFromProduct";
import useTranslate from "@app/_hooks/useTranslate";
import Price from "../price/Price";
export default function ProductCardPrice({
  priceInfo,
}: {
  priceInfo: ReturnType<typeof getPriceInfoFromProduct>;
}) {
  const t = useTranslate();

  return (
    <div className="flex flex-row flex-wrap gap-x-1">
      <Price
        prefix={priceInfo.fromPrice ? t("fromShortened") : undefined}
        price={priceInfo.price}
      />
      {(priceInfo.priceType === PriceType.campaign ||
        priceInfo.priceType === PriceType.pricematch) && (
        <Price
          className="text-gray-500 line-through"
          price={priceInfo.priceRrp ?? priceInfo.price}
        />
      )}
    </div>
  );
}

ProductCardPrice.displayName = "ProductCardPrice";
